import * as React from 'react';

import { Link, Redirect } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Modal from 'antd/lib/modal';
import { bindActionCreators } from 'redux';

import LoginPage from '@common/react/components/Pages/Login/Login';

import { ApplicationState } from '@app/store';
import * as LoginState from '@app/store/Login';

interface Props {
	visible: boolean;
	handleClose: () => void;
	afterLogin: () => void;
}

interface FormValues {
	login: string;
	password: string;
}

const LoginForm: React.FC<Props> = ({ visible, handleClose, afterLogin }) => {
	const loginState = useSelector((state: ApplicationState) => state.login, shallowEqual);
	const [afterLoginTrigger, setLoginTrigger] = React.useState(false);

	const dispatch = useDispatch();
	const loginActions: LoginState.LoginActionCreators = React.useMemo(() =>
		bindActionCreators(LoginState.getActionCreators(), dispatch), []);

	const handleSubmit = (values: FormValues) => {
		loginActions.login(values.login, values.password, 'authPortal');
		setLoginTrigger(true);
	};

	React.useEffect(() => {
		if (loginState.user && afterLoginTrigger) {
			afterLogin();
			setLoginTrigger(false);
		}
	}, [!!loginState.user]);

	return (
		<Modal
			title="Login"
			centered
			open={visible}
			onCancel={handleClose}
			footer={null}
			width={500}
			destroyOnClose
			maskClosable={false}
			getContainer={() => document.querySelector('.app-container') || document.body}
		>
			<div className="enter-page__form">
				<LoginPage
					title=""
					withoutServerPage
					afterBaseRedirectUser={() => <></>}
					onSubmit={handleSubmit}
					withFieldTitle
					buttons={<Link to="/registration" className="btn btn-default register-link">Register</Link>}
				/>
			</div>
		</Modal>
	);
};

export default LoginForm;
